module.exports = __webpack_public_path__ + "static/img/preview-03.d961592d.webp";